import React from 'react'
// import SideBarNav from '../../../../Layout/SideBarNav/SideBarNav';

import { Box} from '@mui/material';
import { Container } from '@mui/material';
// import Grid from '@mui/material/Grid';
// import FormControl from '@mui/material/FormControl';
// import Input from '@mui/material/Input';
// import InputLabel from '@mui/material/InputLabel';
// import Button from '@mui/material/Button';
import AddBuilderEEForm from '../Components/AddBuilderEEForm';
export default function AddBuilderEmployeePage() {

  // WILL NEED A USEEFFECT TO GO AND GET ALL THE BUILDER COMPANIES TO FILL IN THE SELECT DROPDOWN...
  // THE BUILDER COMPANY WILL NEED THE NAME AND THE ID AS WELL.
  // THE ID WILL GO IN THE OBJECT FOR THE EMPLOYEE

  return (
    <Box>
        {/* <SideBarNav/> */}
        <Container>
        <AddBuilderEEForm/>
          
        </Container>

    </Box>
  )
}
